const API_BASE_URL = 'https://oebb.macistry.com/api';

export default API_BASE_URL;